/* shared/theme — light/dark/system theme controller.
   Extracted from the prototype's <head> theme bootstrap. Importing this module
   initializes the theme (applies .nx-dark to <html>) and exports NexusTheme.
   The pre-paint inline bootstrap in index.html handles sidebar width only;
   theme is owned here so the app has a single source of truth. */

const KEY = 'nx-theme';
const mql = window.matchMedia('(prefers-color-scheme: dark)');

const read = () => { try { return localStorage.getItem(KEY) || 'light'; } catch (_) { return 'light'; } };
const resolve = (mode) => (mode === 'system' ? (mql.matches ? 'dark' : 'light') : mode);
const apply = (mode) => {
  const eff = resolve(mode);
  document.documentElement.classList.toggle('nx-dark', eff === 'dark');
  document.documentElement.setAttribute('data-theme', eff);
  document.documentElement.setAttribute('data-theme-mode', mode);
};

let current = read();
if (!['light', 'dark', 'system'].includes(current)) current = 'light';
apply(current);

const listeners = new Set();
const notify = () => listeners.forEach((fn) => { try { fn(current, resolve(current)); } catch (_) {} });
mql.addEventListener('change', () => { if (current === 'system') { apply(current); notify(); } });

export const NexusTheme = {
  get: () => current,
  getResolved: () => resolve(current),
  set: (mode) => {
    if (!['light', 'dark', 'system'].includes(mode)) return;
    current = mode;
    try { localStorage.setItem(KEY, mode); } catch (_) {}
    apply(mode);
    notify();
  },
  subscribe: (fn) => { listeners.add(fn); return () => listeners.delete(fn); },
};

/* Mark theme-ready after first paint so transitions don't fire on load. */
requestAnimationFrame(() => requestAnimationFrame(() => {
  document.documentElement.classList.add('nx-theme-ready');
}));

export default NexusTheme;
